<template>
    <view-section-card hideTitle hideDivider>
        <v-row no-gutters>
            <v-col cols="12" md="">
                <view-section-title title="사용여부">
                    <template #actions>
                        <v-switch v-model="form.isActive" v-bind="attrs_switch" @change="emit" />
                    </template>
                </view-section-title>
            </v-col>
            <v-col cols="12" md="auto">
                <v-divider class="d-block d-md-none" />
                <v-divider vertical class="d-none d-md-block" />
            </v-col>
            <v-col cols="12" md="">
                <view-section-title title="기본벤더">
                    <template #actions>
                        <v-switch v-model="form.isPrimary" v-bind="attrs_switch" @change="emit" />
                    </template>
                </view-section-title>
            </v-col>
            <v-col cols="12" md="auto">
                <v-divider class="d-block d-md-none" />
                <v-divider vertical class="d-none d-md-block" />
            </v-col>
            <v-col cols="12" md="">
                <view-section-title title="해외벤더">
                    <template #actions>
                        <v-switch v-model="form.isForeign" v-bind="attrs_switch" @change="emit" />
                    </template>
                </view-section-title>
            </v-col>
        </v-row>
    </view-section-card>
</template>

<script>
import { attrs_switch } from "@/assets/variables/attrs";
import { initManufacturingVendor } from "@/assets/variables/inits";
import { MANUFACTURING_VENDOR_CODES } from "@/assets/variables/constants";

import ViewSectionCard from "@/components/console/dumb/view/view-section-card.vue";
import ViewSectionTitle from "@/components/console/dumb/view/view-section-title.vue";

const codes = Object.values(MANUFACTURING_VENDOR_CODES);

export default {
    components: {
        ViewSectionCard,
        ViewSectionTitle,
    },
    props: {
        value: { type: Object, default: initManufacturingVendor },
    },
    data: () => ({
        form: initManufacturingVendor(),

        codes,
        attrs_switch,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initManufacturingVendor(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>
